import styled from 'styled-components';

export default styled.header`
  margin: 10px 15px;
`;
